export enum ParentAppMessageCommand {
  RESPONSE = '/response',
  OPEN = '/open',
  LOAD_FORM = '/load-form',
  GIVE_CONSENT = '/give-consent',
  REMOVE_CONSENT = '/remove-consent',
}

export enum WidgetAppMessageCommand {
  INIT = '/init',
  EXITED = '/exited',
  CLOSE = '/close',
  SEND = '/send-request',
  FIRST_INTERACTION = '/first-interaction',
}

export interface ParentAppMessage {
  key?: string;
  command?: ParentAppMessageCommand;
  data?: object;
}

export interface WidgetAppMessage {
  key: string;
  command: WidgetAppMessageCommand;
  data: object;
}
